import s from './Header.module.scss'
import {useAppDispatch} from "../../app/hooks";
import avatar from './../../Dropdown.png'
import {LogoutOutlined} from "@mui/icons-material";
import {SignOutThunk} from "../../store/userReducer";
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const dispatch = useAppDispatch()
    const { pathname } = useLocation()

    return (
        <div className={s.header}>
            <div className={s.inner}>
                <div className={s.inner__buttons}>
                    <a
                        href="https://www.gerechte-stadtentwicklung.de/hamburg"
                        target="_blank"
                        rel="noreferrer"
                        className={`${s.inner__btn}`}
                    >
                        Gehen Sie zur Karte
                    </a>
                    <Link
                      to='/'
                      className={`${s.inner__btn} ${ pathname === '/' ? s.inner__btn_active : ''}`}
                    >
                        Pins
                    </Link>
                    <Link
                      to='/users'
                      className={`${s.inner__btn} ${ pathname === '/users' ? s.inner__btn_active : ''}`}
                    >
                        Benutzer
                    </Link>
                    <Link
                      to='/districts'
                      className={`${s.inner__btn} ${ pathname === '/districts' ? s.inner__btn_active : ''}`}
                    >
                        Bezirksobjekt
                    </Link>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    <div style={{
                        cursor: 'not-allowed'
                    }}>
                        <img src={avatar} alt="avatar"/>
                    </div>
                    <div onClick={() => dispatch(SignOutThunk())}>
                        <LogoutOutlined style={{color: '#fff', fontSize: '24px', cursor: 'pointer'}}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
